import React, { useEffect } from 'react';
import datadogRumClient from '../../utils/datadog-rum';
import Loader from '../../components/UI/Loader';
import { UrlParams, UrlParamsType } from './types';

type urlParams = Partial<Record<keyof UrlParamsType, string>>;
interface InAppProps {
  segment: any;
  urlParams: urlParams;
  initialized: boolean;
  updateAnonymousId: (anonId: string) => void;
  initializeInApp: (urlParams: UrlParamsType) => void;
  onError: (e: Error) => void;
  children: React.ReactNode;
}

const addWriaRumContext = (urlParams: urlParams) => {
  const { appVersion, appOs, role } = urlParams || {};
  if (appOs) {
    datadogRumClient.addRumGlobalContext('WRIA', {
      appVersion,
      appOs
    });
  }
  if (role) {
    datadogRumClient.addRumGlobalContext('sessionRole', role);
  }
};

export function InApp({
  segment,
  urlParams,
  initialized,
  updateAnonymousId,
  initializeInApp,
  onError,
  children
}: InAppProps) {
  useEffect(() => {
    try {
      const validatedUrlParams = UrlParams.check(urlParams);
      if (validatedUrlParams?.appOs) {
        updateAnonymousId(validatedUrlParams?.segmentAnonymousId as string);
        initializeInApp(validatedUrlParams);
      }
    } catch (e) {
      if (urlParams?.appOs) {
        segment.trackEvent('Registration Error Triggered', {
          eventProps: {
            registration_step: 'widget_page',
            error_message: 'WRIA url parameters failed type checking',
            urlParams
          }
        });
        onError(e as Error);
      }
    } finally {
      addWriaRumContext(urlParams);
    }
  }, []);

  if (urlParams?.appOs) {
    return initialized ? <>{children}</> : <Loader />;
  }
  return <>{children}</>;
}
